import { React, useContext, useState, } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import IndustryFilter from "../RefineSearchComponents/IndustryFilter";
import SectorFilter from "../RefineSearchComponents/PESectorFilter";
import YearFoundedFilter from "../RefineSearchComponents/YearFoundedFilter";
import InvestorTypeFilter from "../RefineSearchComponents/InvestorTypeFilter";
import InvestorHeadquartersFilter from "../RefineSearchComponents/InvestorHeadquartersFilter";
import FirmTypeFilter from "../RefineSearchComponents/FirmTypeFilter";
import ExitStatusFilterSelect from "../RefineSearchComponents/ExitStatusFilterSelect";
import InvestorIpoSaleFilter from "../RefineSearchComponents/InvestorIpoSaleFilter";
import ReturnMultipleFilter from "../RefineSearchComponents/ReturnMultipleFilter";
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import Tags from "../RefineSearchComponents/Tags";
import { useLocation,  useNavigate } from "react-router";
import { useEffect } from "react";
import axios from "axios";
import { filterSectorByIndutry, tagList, filterLocationUrl, refineSearchSubFirmTypeUrl } from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import { Tooltip } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import DefinitionModal from "../TagDefinitionModal";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import CountryFilter from "../RefineSearchComponents/CountryFilter";
import RegionFilter from "../RefineSearchComponents/RegionFilter";
import StateFilter from "../RefineSearchComponents/StateFilter";
import CityFilter from "../RefineSearchComponents/CityFilter";
import FirmTypeSubMenu from "../RefineSearchComponents/FirmTypeSubMenu";
/**
 * The function `BackedIPORefineSearch` is a React component that renders a form for refining search
 * filters in a web application.
 * @returns a JSX element, which represents the UI of the component.
 */

function BackedIPORefineSearch({ customPathname, generalPathname }) {
    const {
        setSectors,Sectors,lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions,dbDropdown , setDbDropdown ,checkToggleBtn,setToggleDealsBtn,
        onErrorHandler,SwitchState,setSwitchState,dropdown,AllCities,setSubFirmType ,
        InvestorOptions , setInvestorOptions ,TargetCompanyOptions , setTargetCompanyOptions ,
        setrefineSearchFilters, setMonthPickerValue ,refineSearchFilters, getSectorByIndustry, accessControl,HeadquarterCityOptions,setHeadquarterCityOptions,selectedInvestorHeadquartersCity,setSelectedInvestorHeadquartersCity } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(32);
    const navigate = useNavigate();
    const { getToken } = useContext(UserContext);
    // const isMatch = useMatch({ path: routeNames.pe_companies_backed_ipos_pe_vc_investments })
    const location = useLocation();
    const {pathname} = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false


    //local updated options
    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])
    const [EndYearOptions, setEndYearOptions] = useState([]);
    const [StartYearOptions, setStartYearOptions] = useState([])
    const [InvestorTypeOptions, setInvestorTypeOptions] = useState([])
    const [HeadquartersOptions, setHeadquartersOptions] = useState([])
    const [FirmTypeOptions, setFirmTypeOptions] = useState([])
    const [FirmSubTypeOptions, setFirmSubTypeOptions] = useState([])
    const [CountryOptions, setCountryOptions] = useState([])
    const [RegionOptions, setRegionOptions] = useState([])
    const [StateOptions, setStateOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [ExitStatusOptions, setExitStatusOptions] = useState([])
    const [ReturnMultiple, setReturnMultiple] = useState({ from: "", to: "" })
    const [TagSwitchState, setTagSwitchState] = useState(true)
    const [TagsOptions, setTagsOptions] = useState([])
    const [InvestorSaleOptions, setInvestorSaleOptions] = useState([]);
    
    // Centralized popup state management - only one filter popup can be open at a time
    const [openFilterPopup, setOpenFilterPopup] = useState(null);


    // useEffect(() => {
    //     setFirmType(firmTypeResponseData?.investments ?? [])
    // }, [firmTypeResponseData?.investments, setFirmType])

    // useEffect(() => {
    //     setExitStatus(exitStatusResponseData?.exits ?? [])
    // }, [exitStatusResponseData?.exits, setExitStatus]) 

    useEffect(() => {
        const ids = IndustriesOptions?.length > 0 ? 
            IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id) : [];

        if (ids?.length > 0) {
            getSectorByIndustry(ids, "ipos")
        } else {
            setSectors([])
        }

    }, [IndustriesOptions])

    useEffect(() => {
        if(accessControl?.peindustries?.id?.length > 0){
            const ids = accessControl ? accessControl?.peindustries?.id : []
            getSectorByIndustry(ids, "ipos")
        }
    }, [])

  /**
   * The function `applyFilter` updates the refine search filters based on the selected options.
   */
    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedSectors = SectorOptions.filter(option => option.isChecked);   
        const selectedStartYear = StartYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedEndYear = EndYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedInvestorType = InvestorTypeOptions?.filter(option => option.isChecked);
        const selectedHead = HeadquartersOptions?.filter(option => option.isChecked);
        const selectedHeadCity = HeadquarterCityOptions?.filter(option => option.isChecked);
        const selectedFirm = FirmTypeOptions?.filter(option => option.isChecked);
        const selectedFirmSubTypes = FirmSubTypeOptions?.filter(option => option.isChecked);
        const selectedExitStatus = ExitStatusOptions?.filter(option => option.isChecked);
        const selectedIPO = InvestorSaleOptions?.filter(option => option.isChecked);
        const selectedOperators = SwitchState;
        const selectedCountries = CountryOptions?.filter(option => option.isChecked);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked);
        const selectedState = StateOptions?.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedInvestor = InvestorOptions?.filter(option => option.isChecked); 
        // const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        // const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const firmTypeNames = selectedFirm?.filter(firm => firm.isChecked).map(firm => firm.name) ?? [];
        let filteredFirmSubTypes = null;

        const excludedNames = ['Healthcare(PE)', 'Cleantech(PE)', 'Healthcare(VC)', 'Cleantech(VC)'];

        if (firmTypeNames.includes('PE') || firmTypeNames.includes('VC')) {
            filteredFirmSubTypes = selectedFirmSubTypes?.filter(sub => {
                const isPE = sub.name?.includes('(PE)') || sub.originalName?.includes('(PE)');
                const isVC = sub.name?.includes('(VC)') || sub.originalName?.includes('(VC)');

                if (firmTypeNames.includes('PE') && firmTypeNames.includes('VC')) {
                    return isPE || isVC;
                } else if (firmTypeNames.includes('PE')) {
                    return isPE;
                } else if (firmTypeNames.includes('VC')) {
                    return isVC;
                }
                return false;
            })?.map(sub => {
                if (!excludedNames.includes(sub.name)) {
                    return {
                        ...sub,
                        name: sub.name.replace(/\((PE|VC)\)/, ''),
                    };
                }
                return sub;
            }) ?? null;

            if (filteredFirmSubTypes.length === 0) {
                filteredFirmSubTypes = null;
            }
        }

        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                industry: selectedIndustries,
                sector: selectedSectors,
                investorType: selectedInvestorType,
                investorHeadquarters: selectedHead,
                investor_headquaters_city: selectedHeadCity,
                countries: selectedCountries,
                region: selectedRegion,
                state: selectedState,
                city: selectedCity,
                yearFounded: selectedEndYear != null && selectedStartYear != null ? [selectedStartYear, selectedEndYear] : [],
                firmType: selectedFirm,
                firm_Sub_type: filteredFirmSubTypes,
                operator: TagSwitchState ? 1 : 0,
                tags: TagsOptions,
                exitStatus: selectedExitStatus,
                // ladvisors: [],
                // tadvisors: [],
                deals_operator : selectedOperators,
                investor_id : selectedInvestor ,
                target_company:selectedTargetCompany,
            },
            [customPathname]: {
                ...prev[customPathname],
                returnMultiple: ReturnMultiple?.from != "" && ReturnMultiple?.to != "" ? [{ id: 0, name: ReturnMultiple?.from }, { id: 1, name: ReturnMultiple?.to }] : [],
                investorSaleInipo: selectedIPO,
            },
        }))
    checkToggleBtn();
    setSelectedInvestorHeadquartersCity(HeadquarterCityOptions?.filter(option => option.isChecked));
    }

  /**
   * The function `resetFilter` resets a specific filter in the `refineSearchFilters` object by setting
   * its value to an empty object.
   */
    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {}
        }))
        setHeadquarterCityOptions(HeadquarterCityOptions.map(option => {
            if (option.isChecked) {
                return { ...option, isChecked: false };
            }
            return option;
        }));
        setTargetCompanyOptions([]);
        setInvestorOptions([]);
        setSectors([]);
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setToggleDealsBtn(true);
    }
    useEffect(()=>{
        setToggleDealsBtn(true);
      },[customPathname])

    // Submitting Refine Search Form 
   /**
    * The function `refineSearchFilter` updates search filters, resets the month picker value, sets the
    * current page to 1, applies the filter, navigates to a custom pathname if necessary, and sets the
    * selected state to false.
    * @param event - The event parameter is an object that represents the event that triggered the
    * function. It could be an event like a button click or a form submission.
    */
    const refineSearchFilter = (event) => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
            },
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        event.preventDefault();
        setCurrentPage(1);
        // if (isMatch == null) {
        //     navigate(routeNames.pe_companies_backed_ipos_pe_vc_investments);
        // }
        applyFilter();
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
        setSelected(false)

    }

  /**
   * The `onResetClick` function resets the current page, filters, and navigates to a custom pathname
   * if it is different from the current location.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. In this case, it is the click event that occurred when the user clicked on a reset
   * button.
   */
    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        // if (isMatch == null) {
        //     navigate(routeNames.pe_companies_backed_ipos_pe_vc_investments);
        // }
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

   /**
    * The function `accordionClick` sets the selected value to either 0 or the provided value.
    * @param val - The `val` parameter is a value that is passed to the `accordionClick` function. It
    * is used to determine whether the accordion should be selected or deselected.
    */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    const getSearchTags = async (searchText, type) => {
        try {
        const response = await axios.post(tagList, {
            "tag": searchText,
            "type"    : type,
            "includes_secondary_tags": secondaryTagCheck

        }, {
            headers: {
            "Authorization": getToken()
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
        } catch (error) {
            return [];
        }
    }
    useEffect(() => {
        const countryIds = refineSearchFilters[generalPathname]?.countries?.map(value => value.id) ?? [];
        const ids = refineSearchFilters[generalPathname]?.region?.map(value => value.id) ?? [];
        const stateIds = refineSearchFilters[generalPathname]?.state?.map(value => value.id) ?? [];
        const cityIds = refineSearchFilters[generalPathname]?.city?.map(value => value.id) ?? [];
        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],
    
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setCountryOptions(response.data?.countries?.map(option => ({ ...option, isChecked: countryIds.includes(option.id) })))
                setRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
                setStateOptions(response.data.state?.map(option => ({ ...option, isChecked: stateIds.includes(option.id) })))
                setCityOptions(response.data.city?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters,AllCities])

    // useEffect(() => {
    //     const ids = FirmTypeOptions?.filter(industry => industry.isChecked)?.map(option => option.id);

    //     if (ids?.length > 0) {
    //         let firmType = "All";
    //         if (ids.length === 1) {
    //             if (ids[0] === 1) firmType = "PE";
    //             else if (ids[0] === 2) firmType = "VC";
    //             // Add more mappings here if needed
    //         }

    //         axios.post(refineSearchSubFirmTypeUrl, {
    //             firm_type: firmType,
    //         }, {
    //             headers: {
    //                 "Authorization": getToken()
    //             }
    //         }).then(response => {
    //             if (response.status === 200) {
    //                 setSubFirmType(response.data?.firmType ?? []);
    //             } else {
    //                 setSubFirmType([]);
    //             }
    //         }).catch(onErrorHandler);
    //     } else {
    //         setSubFirmType([]);
    //     }
    // }, [FirmTypeOptions]);

    const onCountryChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: ids,
            region: [],
            state: [],
            city: [],
  
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setRegionOptions(response.data?.region)
                setStateOptions(response.data.state)
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }
  
    const onRegionChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: ids,
            state: [],
            city: [],
  
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setStateOptions(response.data.state)
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }
  
    const onStateChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: selectedRegion,
            state: ids,
            city: [],
  
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    const fetchData = async () => {
        const tags = await getSearchTags("ALL", "noncompetitor");
        const competitorTags = await getSearchTags("ALL", "competitor")
        const secondaryTags = await getSearchTags("ALL", "secondary")
        // console.log(tags, competitorTags, 'promi')
        openTagModal(tags, competitorTags, secondaryTags)
    };

    const  [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({})
    const [secondaryTagCheck, setSecondaryTagCheck] = useState(true);
    console.log(defValues, 'showValues');

    const openTagModal = (non_comp, comp, s_tags) => {
        setShowDefinitionModal(true);
        setDefValues({
            non_comp: non_comp,
            comp: comp,
            s_tags: s_tags
        })
    }

    const defCloseHandler = () =>{
        setShowDefinitionModal(false);
        setDefValues({})
    }


    const toggleSwitchState = () => {
        setSwitchState(prevState => prevState === "and" ? "or" : "and");
    };

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    const getPeVcSelectedTypes = () => {
        return FirmTypeOptions?.filter(option => 
        (option.id === 1 || option.id === 2) && option.isChecked
        ) || [];
    };

    useEffect(() => {
        setrefineSearchFilters((prev) => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
                ladvisors: [],
                tadvisors: []
            },
        }))
    }, [])

    const [activeFilterSection, setActiveFilterSection] = useState('keyword');

    const getDealFiltersCount = () => {
        const hasInvestorSale = InvestorSaleOptions?.length > 0 && InvestorSaleOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasExitStatus = ExitStatusOptions?.length > 0 && ExitStatusOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasReturnMultiple = ReturnMultiple?.from !== "" || ReturnMultiple?.to !== "" ? 1 : 0;
        return hasInvestorSale + hasExitStatus + hasReturnMultiple;
    };

    const getCompanyFiltersCount = () => {
        const hasIndustry = IndustriesOptions?.length > 0 && IndustriesOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasSector = SectorOptions?.length > 0 && SectorOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasYear = (StartYearOptions?.length > 0 && StartYearOptions?.some(option => option.isChecked)) || (EndYearOptions?.length > 0 && EndYearOptions?.some(option => option.isChecked)) ? 1 : 0;
        const hasCountry = CountryOptions?.length > 0 && CountryOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasRegion = RegionOptions?.length > 0 && RegionOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasState = StateOptions?.length > 0 && StateOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasCity = CityOptions?.length > 0 && CityOptions?.some(option => option.isChecked) ? 1 : 0;
        return hasIndustry + hasSector + hasYear + hasCountry + hasRegion + hasState + hasCity;
    };

    const getInvestorFiltersCount = () => {
        const hasInvestorType = InvestorTypeOptions?.length > 0 && InvestorTypeOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasHeadquarters = HeadquartersOptions?.length > 0 && HeadquartersOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasHeadquartersCity = HeadquarterCityOptions?.length > 0 && HeadquarterCityOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasFirmType = FirmTypeOptions?.length > 0 && FirmTypeOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasFirmSubType = FirmSubTypeOptions?.length > 0 && FirmSubTypeOptions?.some(option => option.isChecked) ? 1 : 0;
        return hasInvestorType + hasHeadquarters + hasHeadquartersCity + hasFirmType + hasFirmSubType;
    };

    const getKeywordFiltersCount = () => {
        const hasTagFilters = TagsOptions?.length > 0 ? 1 : 0;
        const hasInvestor = InvestorOptions?.length > 0 && InvestorOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasTargetCompany = TargetCompanyOptions?.length > 0 && TargetCompanyOptions?.some(option => option.isChecked) ? 1 : 0;
        return hasTagFilters + hasInvestor + hasTargetCompany;
    };

    return (
        <div className="bg-white">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full flex flex-col">
                    <main className="flex-1 w-full md:py-4 overflow-y-auto">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 h-full">
                            {/* Left Sidebar - Filter Categories - Horizontal on mobile, vertical on md+ */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap">
                                <div 
                                    className={`cursor-pointer p-2 xs:p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center justify-between gap-1 xs:gap-1 md:gap-2">
                                        <span className="text-xs xs:text-sm md:text-base font-medium">Keyword Search</span>
                                        {getKeywordFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getKeywordFiltersCount()}
                                            </span>
                                        )}
                                        {activeFilterSection === 'keyword' ? <IoMdArrowDropdown size={14} /> : <IoMdArrowDropright size={14} />}
                                    </div>
                                </div>
                                
                                <div 
                                    className={`cursor-pointer p-2 xs:p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center justify-between gap-1 xs:gap-1 md:gap-2">
                                        <span className="text-xs xs:text-sm md:text-base font-medium">Deal</span>
                                        {getDealFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getDealFiltersCount()}
                                            </span>
                                        )}
                                        {activeFilterSection === 'deal' ? <IoMdArrowDropdown size={14} /> : <IoMdArrowDropright size={14} />}
                                    </div>
                                </div>
                                
                                <div 
                                    className={`cursor-pointer p-2 xs:p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center justify-between gap-1 xs:gap-1 md:gap-2">
                                        <span className="text-xs xs:text-sm md:text-base font-medium">Company</span>
                                        {getCompanyFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'company' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getCompanyFiltersCount()}
                                            </span>
                                        )}
                                        {activeFilterSection === 'company' ? <IoMdArrowDropdown size={14} /> : <IoMdArrowDropright size={14} />}
                                    </div>
                                </div>
                                
                                <div 
                                    className={`cursor-pointer p-2 xs:p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'investor' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'investor' ? null : 'investor')}
                                >
                                    <div className="flex items-center justify-between gap-1 xs:gap-1 md:gap-2">
                                        <span className="text-xs xs:text-sm md:text-base font-medium">Investor</span>
                                        {getInvestorFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'investor' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getInvestorFiltersCount()}
                                            </span>
                                        )}
                                        {activeFilterSection === 'investor' ? <IoMdArrowDropdown size={14} /> : <IoMdArrowDropright size={14} />}
                                    </div>
                                </div>
                            </div>
                            
                            {/* Right Content Area - Filter Options */}
                            <div className="overflow-hidden md:overflow-visible mt-4 md:mt-0 pb-0 md:pb-0 md:col-span-6 h-full flex flex-col">
                                <div className={`w-full lg:w-2/4 h-full ${activeFilterSection === 'keyword' ? '' : 'hidden'} relative flex flex-col overflow-y-auto md:overflow-y-visible`}>
                                    <div className="space-y-3 md:space-y-4 flex-shrink-0">
                                        <div className="flex items-center gap-2 md:gap-4 border border-gray-300 rounded-md p-1 md:gap-0">
                                            <div className="p-0 m-0 bg-white input-search relative flex items-center w-full">
                                                <Tags
                                                    TagsOptions={TagsOptions}
                                                    customPathname={generalPathname}
                                                    setTagsOptions={setTagsOptions}
                                                    getSearchTags={getSearchTags}
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                />
                                                <Switch
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                    customPathname={generalPathname} 
                                                />
                                            </div>
                                            <div className="md:hidden flex items-center">
                                                <Tooltip title='Tag List'>
                                                    <FaInfoCircle 
                                                        size={16} 
                                                        color="grey" 
                                                        className="cursor-pointer px-[1px]"
                                                        onClick={fetchData}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="mt-2 cursor-pointer flex justify-end items-center text-xs gap-1">
                                            <input type="checkbox" checked={secondaryTagCheck} onChange={() => setSecondaryTagCheck(!secondaryTagCheck)} title="includes secondary tags" />
                                            <span>include secondary tags</span>
                                        </div>
                                        <Tooltip title='Tag List'>
                                            <FaInfoCircle 
                                                size={16} 
                                                color="grey" 
                                                className="cursor-pointer hidden md:block absolute md:left-[103%] md:top-0"
                                                onClick={fetchData}
                                            />
                                        </Tooltip>
                                    </div>
                                    <div className="flex-1 mt-3 md:mt-4 overflow-y-auto min-h-0">
                                        <div className="space-y-3 md:space-y-4 pb-4">
                                        <Investor 
                                            options={InvestorOptions}
                                            setOptions={setInvestorOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(32)}
                                            label="Investor"
                                            open={select === 32}
                                        />
                                        <TargetCompany 
                                            options={TargetCompanyOptions}
                                            setOptions={setTargetCompanyOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(31)}
                                            label="Company"
                                            open={select === 31}
                                        />
                                    </div>
                                    </div>
                                </div>
                                
                                {/* Deal Section */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4 md:gap-8 ${activeFilterSection === 'deal' ? '' : 'hidden'} pb-2`}>
                                    <InvestorIpoSaleFilter
                                        InvestorSaleOptions={InvestorSaleOptions}
                                        setInvestorSaleOptions={setInvestorSaleOptions}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'investorSaleIpo'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorSaleIpo' : null)}
                                        />
                                    <ExitStatusFilterSelect
                                        ExitStatusOptions={ExitStatusOptions}
                                        setExitStatusOptions={setExitStatusOptions}
                                        customPathname={generalPathname}
                                        dataPath="exits"
                                        defaultLabel="Select"
                                        isPopupOpen={openFilterPopup === 'exitStatus'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'exitStatus' : null)} />
                                    <ReturnMultipleFilter
                                        customPathname={customPathname}
                                        ReturnMultiple={ReturnMultiple}
                                        setReturnMultiple={setReturnMultiple}
                                        isPopupOpen={openFilterPopup === 'returnMultiple'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'returnMultiple' : null)} />
                                </div>
                                <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4 md:gap-8 ${activeFilterSection === 'company' ? '' : 'hidden'} pb-2`}>
                                        <IndustryFilter
                                            IndustriesOptions={IndustriesOptions}
                                            setIndustriesOptions={setIndustriesOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(1)}
                                            open={select === 1}
                                            isPopupOpen={openFilterPopup === 'industry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'industry' : null)} />
                                        <SectorFilter
                                            SectorOptions={SectorOptions}
                                            setSectorOptions={setSectorOptions}
                                            accordionClick={() => accordionClick(2)}
                                            customPathname={generalPathname}
                                            open={select === 2}
                                            isPopupOpen={openFilterPopup === 'sector'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)} />
                                        <YearFoundedFilter
                                            EndYearOptions={EndYearOptions}
                                            customPathname={generalPathname}
                                            setEndYearOptions={setEndYearOptions}
                                            StartYearOptions={StartYearOptions}
                                            setStartYearOptions={setStartYearOptions}
                                            isPopupOpen={openFilterPopup === 'yearFounded'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'yearFounded' : null)} />
                                        <CountryFilter
                                            CountryOptions={CountryOptions}
                                            setCountryOptions={setCountryOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(10)}
                                            onChange={onCountryChange}
                                            open={select === 10}
                                            isPopupOpen={openFilterPopup === 'country'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'country' : null)} />
                                        <RegionFilter
                                            RegionOptions={RegionOptions}
                                            setRegionOptions={setRegionOptions}
                                            customPathname={generalPathname}
                                            onChange={onRegionChange}
                                            isPopupOpen={openFilterPopup === 'region'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'region' : null)} />
                                        <StateFilter
                                            StateOptions={StateOptions}
                                            setStateOptions={setStateOptions}
                                            customPathname={generalPathname}
                                            onChange={onStateChange}
                                            isPopupOpen={openFilterPopup === 'state'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'state' : null)} />
                                        <CityFilter
                                            CityOptions={CityOptions}
                                            setCityOptions={setCityOptions}
                                            customPathname={generalPathname}
                                            isPopupOpen={openFilterPopup === 'city'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)} />
                                    </div>
                                
                                <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4 md:gap-8 ${activeFilterSection === 'investor' ? '' : 'hidden'} pb-2`}>
                                        <InvestorTypeFilter
                                            InvestorTypeOptions={InvestorTypeOptions}
                                            setInvestorTypeOptions={setInvestorTypeOptions}
                                            customPathname={generalPathname}
                                            isPopupOpen={openFilterPopup === 'investorType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorType' : null)} />
                                        <InvestorHeadquartersFilter
                                            HeadquartersOptions={HeadquartersOptions}
                                            setHeadquartersOptions={setHeadquartersOptions}
                                            customPathname={generalPathname}
                                            setHeadquarterCityOptions={setHeadquarterCityOptions}
                                            HeadquarterCityOptions={HeadquarterCityOptions}
                                            isPopupOpen={openFilterPopup === 'investorHeadquarters'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorHeadquarters' : null)} />
                                        <FirmTypeFilter
                                            FirmTypeOptions={FirmTypeOptions}
                                            setFirmTypeOptions={setFirmTypeOptions}
                                            FirmSubTypeOptions={FirmSubTypeOptions}  
                                            setFirmSubTypeOptions={setFirmSubTypeOptions}
                                            customPathname={generalPathname}
                                            dataPath="investments"
                                            isPopupOpen={openFilterPopup === 'firmType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'firmType' : null)} />
                                    </div>
                                
                                {!activeFilterSection && (
                                    <div className="flex items-center justify-center h-32 md:h-40 text-gray-500 text-sm md:text-base">
                                        <p className="text-center px-4">Select a filter category to view available filters</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                </form>
            </div>
            {showDefinitionModal && <DefinitionModal 
                    values={defValues} 
                    onClose={defCloseHandler} 
                    TagsOptions={TagsOptions} 
                    setTagsOptions={setTagsOptions}
                    customPathname={generalPathname}
                />}
        </div>
    )
}

export default BackedIPORefineSearch